import React, { Suspense } from 'react';

import styled from 'styled-components';

import { useFlightsList } from './hooks/useFlightsList';
import { FlightsThrobber } from './components/FlightsThrobber';
import type { FlightsData } from '../../../types/flights';

const FlightsItem = React.lazy(
  () => import(/* webpackChunkName: "FlightsItem" */ '../FlightsItemContainer'),
);

type Props = {
  items: FlightsData[];
  isActive: boolean;
  setVisibleFlights: (value: number) => void;
  visibleFlightsCount: number;
};

export const FlightsByClass = ({
  items,
  isActive,
  setVisibleFlights,
  visibleFlightsCount,
}: Props): JSX.Element | null => {
  const { visibleFlights, onClick, observerTriggerRef } = useFlightsList({
    flightsCount: items.length,
    visibleFlights: visibleFlightsCount,
    setVisibleFlights,
  });

  const list = items.slice(0, visibleFlights);

  return (
    <Suspense fallback={null}>
      <FlightsListContainer>
        {list.map((data, idx) => (
          <FlightsItem
            isFirst={idx === 0}
            key={data.back[0].flight_pair_id}
            data={data}
            active={isActive}
          />
        ))}
        <ButtonContainer ref={observerTriggerRef}>
          {items.length > visibleFlights && (
            <FlightsThrobber onClick={onClick} />
          )}
        </ButtonContainer>
      </FlightsListContainer>
    </Suspense>
  );
};

const FlightsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ButtonContainer = styled.div`
  margin: 10px auto 20px;
  height: 50px;
  display: flex;
  justify-content: center;
`;
